
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7a509e562d0a91f5d2eb2801386c1e1c.jpg"
          alt="Digital Security Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1a2332]/95 via-[#1a2332]/85 to-blue-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 py-32">
        <div className="max-w-2xl">
          <h1 className="text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
            SECURE YOUR<br />DIGITAL FREEDOM
          </h1>
          <p className="text-xl text-gray-300 mb-12 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Enterprise-grade VPN protection for your privacy and security
          </p>
          <button
            onClick={scrollToContact}
            className="group bg-black text-white px-12 py-4 rounded-full text-base font-semibold hover:bg-gray-900 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            GET STARTED
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute right-20 top-1/4 w-32 h-32 border-2 border-blue-400/30 rounded-full animate-pulse"></div>
      <div className="absolute right-40 bottom-1/3 w-20 h-20 border-2 border-cyan-400/30 rounded-lg rotate-45 animate-pulse" style={{ animationDelay: '1s' }}></div>
    </section>
  );
}
